import React from 'react';

import styled from '@emotion/styled';
import { mq, green02, green01, baseDurationTime } from '../../_style';
import { Link } from 'gatsby';

const Container = styled.a(props => `
  border: 1px solid ${green02};
  border-radius: 2px;
  display: block;
  font-size: 14px;
  text-align: center;
  padding: 15px 0;
  overflow: hidden;
  position: relative;
  transition: color ${baseDurationTime} ease;
  ${mq.pc} {
    ${props.inline ? 'display: inline-block' : ''};
  }
  &::before {
    background-color: ${green01};
    content: "";
    display: block;
    width: 0;
    height: 150px;
    border-radius: 50% 0 0 50%;
    position: absolute;
    top: 50%;
    left: auto;
    right: 0;
    z-index: -1;
    transform: translateY(-50%);
    transition: width ${baseDurationTime} ease;
  }
  ${mq.pc} {
    &:hover {
      color: #fff;
      border-color: ${green01};
      svg {
        path {
          stroke: #fff;
        }
      }
      &::before {
        width: 120%;
        border-radius: 0 50% 50% 0;
        left: 0;
        right: auto;
      }
    }
  }
  span {
    display: block;
    line-height: 1;
    ${mq.ie} {
      transform: translateY(2px);
    }
    ${mq.pc} {
      padding-left: 30px;
      padding-right: 36px;
    }
    ${mq.sp} {
      padding-right: 6px;
    }
  }
  svg {
    bottom: 0;
    height: 11px;
    margin: auto;
    position: absolute;
    right: 17px;
    top: 0;
    width: 6px;
    ${mq.spMin} {
      right: 10px;
    }
    path {
      transition: stroke ${baseDurationTime} ease;
    }
  }
`);

const ContainerLink = Container.withComponent(Link);

export default class Btn extends React.Component {
  render() {
    return (
      <ContainerLink to={this.props.to} green={this.props.green} inline={this.props.inline ? 1 : 0}>
        <span>{this.props.children}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="6.438"
          height="10.44"
          viewBox="0 0 6.438 10.44"
        >
          <path
            data-name="長方形 1544"
            d="M.515 9.22l4-4-4-4"
            fill="none"
            stroke={green01}
          />
        </svg>
      </ContainerLink>
    );
  }
}
